var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4v16h4v5.08L12.352 20H22V4H2zm2 2h16v12h-8.352L8 20.918V18H4V6zm20 2v2h4v12h-4v2.92L20.352 22h-7.504l-2.5 2h9.3L26 29.08V24h4V8h-6zM6 9v2h12V9H6zm0 4v2h7v-2H6z"
  })));
};
export default SvgChat;